import { Component, OnInit, ChangeDetectionStrategy, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-view-tour-tip-button',
  templateUrl: './view-tour-tip-button.component.html',
  styleUrls: ['./view-tour-tip-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewTourTipButtonComponent implements OnInit {

  @Input()
  label: string;

  @Input()
  icon: string;

  constructor() { }

  ngOnInit() {
  }

}
